module.exports = __webpack_public_path__ + "img/629f4c5.jpg";